module.exports = __webpack_public_path__ + "static/media/elements@2x.521d4dfe.png";